// Shared navigation header. GITEX RULE #2 requires every page to use this one
// component. Labels are i18n keys; the language toggle flips PL/EN.
import { useLanguage } from '../context/LanguageContext';
import type { MessageKey } from '../i18n/en';
import styles from './NavHeader.module.css';

export type NavView = 'dashboard' | 'positions' | 'settings' | 'watchlist' | 'momentum';

interface NavHeaderProps {
  readonly active: NavView;
  readonly onNavigate: (view: NavView) => void;
}

const ITEMS: ReadonlyArray<{ view: NavView; key: MessageKey }> = [
  { view: 'dashboard', key: 'nav.dashboard' },
  { view: 'positions', key: 'nav.positions' },
  { view: 'settings', key: 'nav.settings' },
  { view: 'watchlist', key: 'nav.watchlist' },
  { view: 'momentum', key: 'nav.momentum' },
];

export function NavHeader({ active, onNavigate }: NavHeaderProps): JSX.Element {
  const { t, lang, setLang } = useLanguage();
  return (
    <header className={styles.header}>
      <span className={styles.brand}>{t('app.title')}</span>
      <nav className={styles.nav}>
        {ITEMS.map((item) => (
          <button
            key={item.view}
            type="button"
            className={`${styles.link} ${active === item.view ? styles.active : ''}`}
            onClick={() => onNavigate(item.view)}
          >
            {t(item.key)}
          </button>
        ))}
      </nav>
      <button
        type="button"
        className={styles.langToggle}
        onClick={() => setLang(lang === 'en' ? 'pl' : 'en')}
      >
        {t('lang.toggle')}
      </button>
    </header>
  );
}
